import { call, put, all, takeEvery } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import * as UrlUtil from '../utils/UrlUtil';
import { WellnessGoalTypes } from 'DailySummary/utils/DailySummaryPageUtil';
import { fetchIntensityMinutesSaga } from 'sagas/intensityMinutesSagas';
import DateParser from 'utils/date/DateParser';
import DateFormatter from 'utils/date/DateFormatter';
import {
    FETCH_MERGED_SUMMARY,
    FETCH_MERGED_SUMMARY_FETCHING,
    FETCH_MERGED_SUMMARY_SUCCESS,
    FETCH_MERGED_SUMMARY_FAIL,
    FETCH_MERGED_SUMMARY_COUNT,
    FETCH_MERGED_SUMMARY_COUNT_SUCCESS,
    FETCH_MERGED_SUMMARY_COUNT_FAIL,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL,
    FETCH_ACTIVITIES_LIST,
    FETCH_ACTIVITIES_LIST_SUCCESS,
    FETCH_ACTIVITIES_LIST_FETCHING,
    FETCH_ACTIVITIES_LIST_FAIL,
    FETCH_AUTO_DETECTED_EVENTS,
    FETCH_AUTO_DETECTED_EVENTS_SUCCESS,
    FETCH_AUTO_DETECTED_EVENTS_FAIL,
    FETCH_WELLNESS_DAILY_STRESS_DATA,
    FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL,
    FETCH_DAILY_MOVEMENT,
    FETCH_DAILY_MOVEMENT_FETCHING,
    FETCH_DAILY_MOVEMENT_SUCCESS,
    FETCH_DAILY_MOVEMENT_FAIL,
    FETCH_DAILY_HEART_RATE,
    FETCH_DAILY_HEART_RATE_SUCCESS,
    FETCH_DAILY_HEART_RATE_FAIL,
    FETCH_LAST_SYNC_TIMESTAMP,
    FETCH_LAST_SYNC_TIMESTAMP_SUCCESS,
    FETCH_LAST_SYNC_TIMESTAMP_FAIL,
    FETCH_WELLNESS_GOALS,
    FETCH_WELLNESS_GOALS_FETCHING,
    FETCH_WELLNESS_GOALS_SUCCESS,
    FETCH_WELLNESS_GOALS_FAIL,
    FETCH_CONSOLIDATED_STEP_GOAL,
    FETCH_CONSOLIDATED_STEP_GOAL_FETCHING,
    FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS,
    FETCH_CONSOLIDATED_STEP_GOAL_FAIL,
    FETCH_CONSOLIDATED_PUSHES_GOAL,
    FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING,
    FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
    FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL,
    FETCH_DAILY_STEPS,
    FETCH_DAILY_STEPS_FETCHING,
    FETCH_DAILY_STEPS_SUCCESS,
    FETCH_DAILY_STEPS_FAIL,
    FETCH_BODY_BATTERY_TODAY,
    FETCH_BODY_BATTERY_TODAY_SUCCESS,
    FETCH_BODY_BATTERY_TODAY_FAIL,
    SAVE_MERGED_SUMMARY,
    SAVE_MERGED_SUMMARY_SUCCESS,
    UPDATE_CONSOLIDATED_STEP_GOAL,
    UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS,
    UPDATE_CONSOLIDATED_STEP_GOAL_FAIL,
    UPDATE_CONSOLIDATED_PUSHES_GOAL,
    UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
    UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL,
    UPDATE_WELLNESS_GOALS,
    UPDATE_WELLNESS_GOALS_SUCCESS,
    UPDATE_WELLNESS_GOALS_FAIL,
    UPDATE_WELLNESS_GOALS_UPDATING,
    DELETE_ABNORMAL_HEART_RATE,
    DELETE_ABNORMAL_HEART_RATE_START,
    DELETE_ABNORMAL_HEART_RATE_SUCCESS,
    DELETE_ABNORMAL_HEART_RATE_FAIL,
    FETCH_PUSHES_DAILY_AVERAGE,
    FETCH_PUSHES_DAILY_AVERAGE_FETCHING,
    FETCH_PUSHES_DAILY_AVERAGE_FAIL,
    FETCH_PUSHES_DAILY_AVERAGE_SUCCESS
} from '../actions/ActionTypes';

import {
    CHECK_EXPORTABILITY,
    CHECK_EXPORTABILITY_SUCCESS,
    CHECK_EXPORTABILITY_FAIL,
    CHECK_EXPORTABILITY_FETCHING
} from 'actions/dailySummaryActions.js';
import {
    DELETE_DAILY_SUMMARY,
    DELETE_DAILY_SUMMARY_SUCCESS,
    DELETE_DAILY_SUMMARY_FAIL
} from '../actions/dailySummaryActions';

// Workers
export function* fetchMergedSummarySaga(action) {
    yield put({
        type: FETCH_MERGED_SUMMARY_FETCHING
    });

    const { displayName, calendarDate } = action;

    const queryParams = UrlUtil.toQueryString({
        calendarDate: calendarDate
    });

    if (!displayName) {
        yield put({
            type: FETCH_MERGED_SUMMARY_FAIL,
            mergedSummary: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    } else {
        try {
            const response = yield call(
                gcApi.get,
                `/usersummary-service/usersummary/daily/${displayName}${queryParams}`
            );

            yield put({
                type: FETCH_MERGED_SUMMARY_SUCCESS,
                mergedSummary: response.data,
                displayName: displayName,
                calendarDate: calendarDate
            });
        } catch (e) {
            yield put({
                type: FETCH_MERGED_SUMMARY_FAIL,
                mergedSummary: {},
                displayName: displayName,
                calendarDate: calendarDate
            });
        }
    }
}

export function* saveMergedSummarySaga(action) {
    try {
        const updatedMergedSummary = action.payload;
        const response = yield call(gcApi.put, `/usersummary-service/usersummary/daily/`, updatedMergedSummary);

        yield put({
            type: SAVE_MERGED_SUMMARY_SUCCESS,
            mergedSummary: response.data
        });
    } catch (e) {}
}

export function* fetchMergedSummaryCountSaga(action) {
    try {
        const response = yield call(gcApi.get, `/usersummary-service/usersummary/dailySummariesCount`);

        yield put({
            type: FETCH_MERGED_SUMMARY_COUNT_SUCCESS,
            mergedSummaryCount: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MERGED_SUMMARY_COUNT_FAIL,
            mergedSummaryCount: {}
        });
    }
}

export function* fetchActivitiesForDailySummarySaga(action) {
    const { displayName, calendarDate } = action;

    const queryParams = UrlUtil.toQueryString({
        calendarDate: calendarDate
    });

    try {
        yield put({
            type: FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/activitylist-service/activities/fordailysummary/${displayName}${queryParams}`
        );

        yield put({
            type: FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS,
            activitiesForDailySummary: response.data,
            calendarDate: calendarDate,
            displayName: displayName
        });
    } catch (e) {
        yield put({
            type: FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL,
            activitiesForDailySummary: [],
            calendarDate: calendarDate,
            displayName: displayName
        });
    }
}

export function* fetchActivitiesListForTimeframeSaga(action) {
    const { displayName, startTimestampLocal, endTimestampLocal, activityTypeId, limit } = action;

    yield put({ type: FETCH_ACTIVITIES_LIST_FETCHING });

    const queryStringObj = {
        startTimestampLocal: startTimestampLocal,
        endTimestampLocal: endTimestampLocal
    };

    if (activityTypeId) {
        queryStringObj.activityTypeId = activityTypeId;
    }

    if (limit) {
        queryStringObj.limit = limit;
    }

    const queryParams = UrlUtil.toQueryString(queryStringObj);

    try {
        const response = yield call(gcApi.get, `/activitylist-service/activities/list/${displayName}${queryParams}`);

        yield put({
            type: FETCH_ACTIVITIES_LIST_SUCCESS,
            activitiesListForTimeframe: response.data,
            startTimestampLocal: startTimestampLocal,
            endTimestampLocal: endTimestampLocal,
            displayName: displayName
        });
    } catch (e) {
        yield put({
            type: FETCH_ACTIVITIES_LIST_FAIL,
            activitiesListForTimeframe: [],
            startTimestampLocal: startTimestampLocal,
            endTimestampLocal: endTimestampLocal,
            displayName: displayName
        });
    }
}

export function* fetchAutoDetectedEventsSaga(action) {
    const { displayName, calendarDate } = action;

    const queryParams = UrlUtil.toQueryString({
        calendarDate: calendarDate
    });

    try {
        const response = yield call(gcApi.get, `/wellness-service/wellness/dailyEvents/${displayName}${queryParams}`);

        yield put({
            type: FETCH_AUTO_DETECTED_EVENTS_SUCCESS,
            autoDetectedEvents: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_AUTO_DETECTED_EVENTS_FAIL,
            autoDetectedEvents: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* fetchDailyStressDataSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        const response = yield call(gcApi.get, `/wellness-service/wellness/dailyStress/${calendarDate}`);

        yield put({
            type: FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS,
            dailyStressData: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL,
            dailyStressData: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* fetchDailyMovementSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        yield put({
            type: FETCH_DAILY_MOVEMENT_FETCHING
        });

        const response = yield call(gcApi.get, `/wellness-service/wellness/dailyMovement?calendarDate=${calendarDate}`);

        yield put({
            type: FETCH_DAILY_MOVEMENT_SUCCESS,
            dailyMovement: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_MOVEMENT_FAIL,
            dailyMovement: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* fetchDailyHeartRateSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        const response = yield call(gcApi.get, `/wellness-service/wellness/dailyHeartRate?date=${calendarDate}`);

        yield put({
            type: FETCH_DAILY_HEART_RATE_SUCCESS,
            dailyHeartRate: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_HEART_RATE_FAIL,
            dailyHeartRate: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* fetchLastSyncTimestampSaga(action) {
    try {
        const response = yield call(gcApi.get, `/wellness-service/wellness/syncTimestamp`);

        yield put({
            type: FETCH_LAST_SYNC_TIMESTAMP_SUCCESS,
            lastSyncTimestamp: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LAST_SYNC_TIMESTAMP_FAIL,
            lastSyncTimestamp: null
        });
    }
}

export function* fetchWellnessGoalsSaga(action) {
    const { calendarDate } = action;

    try {
        yield put({
            type: FETCH_WELLNESS_GOALS_FETCHING
        });

        const response = yield call(gcApi.get, `/goal-service/goal/user/effective/${calendarDate}`);

        yield put({
            type: FETCH_WELLNESS_GOALS_SUCCESS,
            calendarDate: calendarDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WELLNESS_GOALS_FAIL,
            calendarDate: calendarDate,
            data: null
        });
    }
}

export function* fetchConsolidatedStepsGoalSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        yield put({
            type: FETCH_CONSOLIDATED_STEP_GOAL_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/wellness-service/wellness/wellness-goals/consolidated/steps/${calendarDate}`
        );

        yield put({
            type: FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS,
            displayName: displayName,
            calendarDate: calendarDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CONSOLIDATED_STEP_GOAL_FAIL,
            displayName: displayName,
            calendarDate: calendarDate,
            data: null
        });
    }
}

export function* fetchConsolidatedPushesGoalSaga(action) {
    const { calendarDate } = action;
    try {
        yield put({
            type: FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/wellness-service/wellness/wellness-goals/consolidated/pushes/${calendarDate}`
        );

        yield put({
            type: FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
            calendarDate: calendarDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL,
            calendarDate: calendarDate,
            data: null
        });
    }
}

export function* fetchDailyStepsSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        yield put({
            type: FETCH_DAILY_STEPS_FETCHING
        });

        const response = yield call(gcApi.get, `/wellness-service/wellness/dailySummaryChart/?date=${calendarDate}`);

        yield put({
            type: FETCH_DAILY_STEPS_SUCCESS,
            displayName: displayName,
            calendarDate: calendarDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_STEPS_FAIL,
            displayName: displayName,
            calendarDate: calendarDate,
            data: null
        });
    }
}

export function* fetchBodyBatteryTodaySaga(action) {
    const { displayName, calendarDate } = action;

    try {
        const response = yield call(gcApi.get, `/wellness-service/wellness/bodyBattery/messagingToday`);

        yield put({
            type: FETCH_BODY_BATTERY_TODAY_SUCCESS,
            displayName: displayName,
            calendarDate: calendarDate,
            bodyBatteryToday: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_BODY_BATTERY_TODAY_FAIL,
            displayName: displayName,
            calendarDate: calendarDate,
            bodyBatteryToday: null
        });
    }
}

export function* checkIsDailySummaryExportableSaga(action) {
    const { calendarDate } = action;

    yield put({
        type: CHECK_EXPORTABILITY_FETCHING,
        calendarDate: calendarDate
    });

    try {
        const response = yield call(gcApi.head, `/download-service/files/wellness/${calendarDate}`); // just calling HEAD to make sure the file exists

        yield put({
            type: CHECK_EXPORTABILITY_SUCCESS,
            calendarDate: calendarDate,
            isExportable: true
        });
    } catch (exception) {
        yield put({
            type: CHECK_EXPORTABILITY_FAIL,
            calendarDate: calendarDate,
            isExportable: false
        });
    }
}

export function* deleteDailySummarySaga(action) {
    const { calendarDate } = action;

    try {
        const response = yield call(gcApi.delete, `/wellness-service/wellness/dailySummary/${calendarDate}`);

        if (response.status === 204) {
            yield put({
                type: DELETE_DAILY_SUMMARY_SUCCESS,
                calendarDate: calendarDate
            });

            yield put({
                type: FETCH_MERGED_SUMMARY,
                calendarDate: calendarDate,
                displayName: action.displayName
            }); // need to clear out any state we have for this day's merged summary
        }
    } catch (ex) {
        yield put({
            type: DELETE_DAILY_SUMMARY_FAIL,
            calendarDate: calendarDate
        });
    }
}

export function* updateConsolidatedStepsGoalSaga(action) {
    const { displayName, calendarDate, newGoal } = action;

    try {
        const response = yield call(
            gcApi.put,
            `/wellness-service/wellness/wellness-goals/consolidated/steps/${calendarDate}`,
            newGoal
        );

        yield put({
            type: UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS,
            data: response.data,
            calendarDate
        });
        return response;
    } catch (e) {
        yield put({
            type: UPDATE_CONSOLIDATED_STEP_GOAL_FAIL
        });
    }
}

export function* updateConsolidatedPushesGoalSaga(action) {
    const { calendarDate, newGoal } = action;

    try {
        const response = yield call(
            gcApi.put,
            `/wellness-service/wellness/wellness-goals/consolidated/${calendarDate}`,
            newGoal
        );

        yield put({
            type: UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS,
            data: response.data
        });
        return response;
    } catch (e) {
        yield put({
            type: UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL
        });
    }
}

export function* updateWellnessGoalsSaga(action) {
    const { calendarDate, newGoal, currentDate } = action;

    const goalConfig = WellnessGoalTypes[newGoal.goalType];
    const goalType = goalConfig && goalConfig.urlFriendly ? goalConfig.urlFriendly : goalConfig.key.toLowerCase();

    try {
        yield put({
            type: UPDATE_WELLNESS_GOALS_UPDATING
        });

        const response = yield call(
            gcApi.put,
            `/goal-service/goal/user/effective/${goalType}/${calendarDate}`,
            newGoal
        );

        yield put({
            type: UPDATE_WELLNESS_GOALS_SUCCESS,
            calendarDate: calendarDate,
            data: response.data
        });

        if (newGoal.goalType === WellnessGoalTypes.INTENSITY_MINUTES.key) {
            // fetch intensity minutes data to get the adjusted goal
            yield call(fetchIntensityMinutesSaga, { payload: { calendarDate: currentDate } });
        }

        return response;
    } catch (e) {
        yield put({
            type: UPDATE_WELLNESS_GOALS_FAIL
        });
    }
}

export function* deleteAbnormalHeartRate(action) {
    const { eventTimestamp } = action.payload;
    try {
        yield put({
            type: DELETE_ABNORMAL_HEART_RATE_START
        });

        const dateTimeObj = DateParser.parseISOUTC(eventTimestamp);
        const timestamp = DateFormatter.formatConnectTimestampUTC(dateTimeObj);

        const response = yield call(gcApi.delete, `/wellness-service/wellness/abnormalHeartRate/${timestamp}`);

        yield put({
            type: DELETE_ABNORMAL_HEART_RATE_SUCCESS,
            payload: action.payload
        });
    } catch (e) {
        yield put({
            type: DELETE_ABNORMAL_HEART_RATE_FAIL
        });
    }
}

export function* fetchPushesDailyAverageSaga(action) {
    const { calendarDate } = action;

    try {
        yield put({
            type: FETCH_PUSHES_DAILY_AVERAGE_FETCHING
        });

        const response = yield call(gcApi.get, `/usersummary-service/stats/pushes/weekly/${calendarDate}/1`);

        yield put({
            type: FETCH_PUSHES_DAILY_AVERAGE_SUCCESS,
            calendarDate,
            data: response.data[0].values.averagePushes
        });
    } catch (error) {
        yield put({
            type: FETCH_PUSHES_DAILY_AVERAGE_FAIL,
            calendarDate
        });
    }
}

// Watchers
export const dailySummarySagas = [
    takeEvery(FETCH_MERGED_SUMMARY, fetchMergedSummarySaga),
    takeEvery(FETCH_MERGED_SUMMARY_COUNT, fetchMergedSummaryCountSaga),
    takeEvery(FETCH_ACTIVITIES_FOR_DAILY_SUMMARY, fetchActivitiesForDailySummarySaga),
    takeEvery(FETCH_ACTIVITIES_LIST, fetchActivitiesListForTimeframeSaga),
    takeEvery(FETCH_AUTO_DETECTED_EVENTS, fetchAutoDetectedEventsSaga),
    takeEvery(FETCH_WELLNESS_DAILY_STRESS_DATA, fetchDailyStressDataSaga),
    takeEvery(FETCH_DAILY_MOVEMENT, fetchDailyMovementSaga),
    takeEvery(FETCH_DAILY_HEART_RATE, fetchDailyHeartRateSaga),
    takeEvery(FETCH_LAST_SYNC_TIMESTAMP, fetchLastSyncTimestampSaga),
    takeEvery(FETCH_WELLNESS_GOALS, fetchWellnessGoalsSaga),
    takeEvery(FETCH_CONSOLIDATED_STEP_GOAL, fetchConsolidatedStepsGoalSaga),
    takeEvery(FETCH_CONSOLIDATED_PUSHES_GOAL, fetchConsolidatedPushesGoalSaga),
    takeEvery(FETCH_DAILY_STEPS, fetchDailyStepsSaga),
    takeEvery(FETCH_BODY_BATTERY_TODAY, fetchBodyBatteryTodaySaga),
    takeEvery(SAVE_MERGED_SUMMARY, saveMergedSummarySaga),
    takeEvery(CHECK_EXPORTABILITY, checkIsDailySummaryExportableSaga),
    takeEvery(DELETE_DAILY_SUMMARY, deleteDailySummarySaga),
    takeEvery(UPDATE_CONSOLIDATED_STEP_GOAL, updateConsolidatedStepsGoalSaga),
    takeEvery(UPDATE_CONSOLIDATED_PUSHES_GOAL, updateConsolidatedPushesGoalSaga),
    takeEvery(UPDATE_WELLNESS_GOALS, updateWellnessGoalsSaga),
    takeEvery(DELETE_ABNORMAL_HEART_RATE, deleteAbnormalHeartRate),
    takeEvery(FETCH_PUSHES_DAILY_AVERAGE, fetchPushesDailyAverageSaga)
];
